import { render, staticRenderFns } from "./TipoAcao.vue?vue&type=template&id=ca59e1f6&lang=html&"
import script from "./TipoAcao.vue?vue&type=script&lang=js&"
export * from "./TipoAcao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/tipo-acao/TipoAcao.vue
// module id = 1519
// module chunks = 28